/* Relax Spa & Bath theme scripts */
(function () {
  'use strict';

  function initBurger() {
    var burger = document.querySelector('[data-rsb-burger]');
    var menu = document.querySelector('[data-rsb-mobile-menu]');
    if (!burger || !menu) return;
    burger.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    // collapsible submenus
    menu.querySelectorAll('[data-rsb-m-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-rsb-m-group]');
        if (!group) return;
        var kids = group.querySelector('[data-rsb-m-children]');
        var caret = btn.querySelector('[data-rsb-m-caret]');
        var open = kids.style.display !== 'block';
        kids.style.display = open ? 'block' : 'none';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (caret) caret.style.transform = open ? 'rotate(180deg)' : 'none';
      });
    });
  }

  function initAccordions() {
    document.querySelectorAll('[data-rsb-accordion] [data-rsb-acc-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-rsb-acc-item]');
        if (!item) return;
        var panel = item.querySelector('[data-rsb-acc-panel]');
        var icon = item.querySelector('[data-rsb-acc-icon]');
        var open = item.classList.toggle('is-open');
        if (panel) panel.style.display = open ? 'block' : 'none';
        if (icon) icon.textContent = open ? '−' : '+';
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initSearch() {
    var popup = document.querySelector('[data-rsb-search-popup]');
    if (!popup) return;
    var input = popup.querySelector('[data-rsb-search-input]') || popup.querySelector('input[name="q"]');
    var results = popup.querySelector('[data-rsb-search-results]');
    function open() { popup.hidden = false; document.body.style.overflow = 'hidden'; if (input) setTimeout(function () { input.focus(); }, 30); }
    function close() { popup.hidden = true; document.body.style.overflow = ''; }
    document.querySelectorAll('[data-rsb-search-toggle]').forEach(function (b) { b.addEventListener('click', open); });
    popup.querySelectorAll('[data-rsb-search-close]').forEach(function (b) { b.addEventListener('click', close); });
    popup.addEventListener('click', function (e) { if (e.target === popup) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !popup.hidden) close(); });

    if (!input || !results) return;
    var money = (window.Shopify && Shopify.formatMoney) ? null : null;
    function fmt(cents) { return '$' + (cents / 100).toFixed(2); }
    function row(href, imgHtml, title, sub, tag) {
      return '<a href="' + href + '" style="display:flex;align-items:center;gap:14px;padding:10px 8px;border-radius:12px;text-decoration:none;">' +
        imgHtml +
        '<span style="display:flex;flex-direction:column;gap:2px;min-width:0;">' +
        (tag ? '<span style="font-size:10.5px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:#2E6F66;">' + tag + '</span>' : '') +
        '<span style="font-size:14.5px;font-weight:600;color:#3A3A34;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + title + '</span>' +
        (sub ? '<span style="font-size:13px;color:#6E6E68;">' + sub + '</span>' : '') +
        '</span></a>';
    }
    function render(data, term) {
      var r = (data.resources && data.resources.results) || {};
      var html = '';
      (r.products || []).forEach(function (p) {
        var img = p.featured_image && p.featured_image.url
          ? '<img src="' + p.featured_image.url + '" alt="" width="48" height="48" style="width:48px;height:48px;border-radius:10px;object-fit:cover;flex:0 0 auto;">'
          : '<span style="width:48px;height:48px;border-radius:10px;background:#EAF4F2;flex:0 0 auto;"></span>';
        html += row(p.url, img, p.title, p.price ? fmt(p.price) : '', null);
      });
      (r.pages || []).forEach(function (pg) { html += row(pg.url, '', pg.title, '', 'Page'); });
      (r.articles || []).forEach(function (a) { html += row(a.url, '', a.title, '', 'Article'); });
      if (html) {
        html += '<a href="/search?q=' + encodeURIComponent(term) + '" style="display:block;text-align:center;padding:12px;margin-top:6px;font-size:14px;font-weight:700;color:#2E6F66;text-decoration:none;border-top:1px solid rgba(58,58,52,.12);">See all results for &ldquo;' + term + '&rdquo; →</a>';
        results.innerHTML = html;
      } else {
        results.innerHTML = '<div style="padding:16px 8px;color:#6E6E68;font-size:14px;">No matches for &ldquo;' + term + '&rdquo;.</div>';
      }
    }
    var timer, controller;
    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(timer);
      if (term.length < 3) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
          '&resources[type]=product,page,article&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { signal: controller.signal, headers: { 'Accept': 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (data) { render(data, term); })
          .catch(function () {});
      }, 220);
    });
  }

  // Product image gallery + lightbox
  function initGallery() {
    var gallery = document.querySelector('[data-rsb-gallery]');
    if (!gallery) return;
    var mains = gallery.querySelectorAll('[data-rsb-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-rsb-gallery-thumb]');
    var total = mains.length || 1;
    var cur = 0;

    function setMain(i) {
      cur = (i + total) % total;
      mains.forEach(function (m) { m.style.display = (+m.getAttribute('data-rsb-gallery-main')) === cur ? 'block' : 'none'; });
      thumbs.forEach(function (t) {
        var on = (+t.getAttribute('data-rsb-gallery-thumb')) === cur;
        t.style.border = '2px solid ' + (on ? 'var(--rsb-accent)' : 'rgb(230, 227, 217)');
        if (on && t.scrollIntoView) t.scrollIntoView({ inline: 'nearest', block: 'nearest' });
      });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { setMain(+t.getAttribute('data-rsb-gallery-thumb')); }); });

    // thumbnail strip slide controls
    var strip = gallery.querySelector('[data-rsb-thumbs]');
    var tp = gallery.querySelector('[data-rsb-thumbs-prev]');
    var tn = gallery.querySelector('[data-rsb-thumbs-next]');
    if (strip && tp) tp.addEventListener('click', function () { strip.scrollBy({ left: -180, behavior: 'smooth' }); });
    if (strip && tn) tn.addEventListener('click', function () { strip.scrollBy({ left: 180, behavior: 'smooth' }); });

    // lightbox
    var lb = gallery.querySelector('[data-rsb-lightbox]');
    if (!lb) return;
    var lbImgs = lb.querySelectorAll('[data-rsb-lightbox-img]');
    var counter = lb.querySelector('[data-rsb-lightbox-counter]');
    function showLb(i) {
      cur = (i + total) % total;
      lbImgs.forEach(function (m) { m.style.display = (+m.getAttribute('data-rsb-lightbox-img')) === cur ? 'block' : 'none'; });
      if (counter) counter.textContent = (cur + 1) + ' / ' + total;
      setMain(cur);
    }
    function openLb() { if (lb.parentNode !== document.body) document.body.appendChild(lb); lb.hidden = false; requestAnimationFrame(function () { lb.classList.add('is-open'); }); document.body.style.overflow = 'hidden'; showLb(cur); }
    function closeLb() { lb.classList.remove('is-open'); document.body.style.overflow = ''; setTimeout(function () { lb.hidden = true; }, 300); }

    var viewer = gallery.querySelector('[data-rsb-gallery-viewer]');
    var openBtn = gallery.querySelector('[data-rsb-gallery-open]');
    if (viewer) viewer.addEventListener('click', function (e) { if (e.target.closest('[data-rsb-gallery-open]')) return; openLb(); });
    if (openBtn) openBtn.addEventListener('click', function (e) { e.stopPropagation(); openLb(); });
    lb.querySelector('[data-rsb-lightbox-close]').addEventListener('click', closeLb);
    lb.querySelector('[data-rsb-lightbox-prev]').addEventListener('click', function () { showLb(cur - 1); });
    lb.querySelector('[data-rsb-lightbox-next]').addEventListener('click', function () { showLb(cur + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.hasAttribute('data-rsb-lightbox-stage')) closeLb(); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') closeLb();
      else if (e.key === 'ArrowLeft') showLb(cur - 1);
      else if (e.key === 'ArrowRight') showLb(cur + 1);
    });
  }

  // Quantity stepper
  function initQty() {
    document.querySelectorAll('[data-rsb-qty]').forEach(function (input) {
      var wrap = input.parentElement;
      var minus = wrap.querySelector('[data-rsb-qty-minus]');
      var plus = wrap.querySelector('[data-rsb-qty-plus]');
      function val() { return Math.max(1, parseInt(input.value, 10) || 1); }
      if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, val() - 1); });
      if (plus) plus.addEventListener('click', function () { input.value = val() + 1; });
      input.addEventListener('change', function () { input.value = val(); });
    });
  }

  // Variant select -> update displayed price
  function initVariant() {
    var select = document.querySelector('[data-rsb-variant]');
    if (!select) return;
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var price = opt && opt.getAttribute('data-price');
      if (price) {
        var p = document.querySelector('[data-rsb-price]');
        var bp = document.querySelector('[data-rsb-btn-price]');
        if (p) p.textContent = price;
        if (bp) bp.textContent = price;
      }
    });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-rsb-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* Free-shipping progress bar (announcement). Recomputes remaining from the live cart total. */
  function updateShipBar(cart) {
    if (!cart) return;
    document.querySelectorAll('[data-rsb-shipbar]').forEach(function (bar) {
      var txt = bar.querySelector('[data-rsb-shipbar-text]');
      if (!txt) return;
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
      var remaining = threshold - (cart.total_price || 0);
      if (threshold > 0 && remaining > 0) {
        txt.innerHTML = "You're $" + (remaining / 100).toFixed(2) + " away from <strong>free shipping</strong>!";
      } else {
        txt.innerHTML = "🎉 You've unlocked <strong>free shipping</strong>!";
      }
    });
  }

  /* ---------------- Cart drawer ---------------- */
  function openDrawer() { document.body.classList.add('rsb-drawer-open'); }
  function closeDrawer() { document.body.classList.remove('rsb-drawer-open'); }

  function refreshDrawer() {
    return fetch('/?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-rsb-cart-drawer-root]');
        var live = document.querySelector('[data-rsb-cart-drawer-root]');
        if (fresh && live) live.innerHTML = fresh.innerHTML;
      });
  }

  function syncCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); updateShipBar(cart); return cart; });
  }

  function addToCart(body, btn) {
    var original = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.d && res.d.description) || 'Could not add to cart');
        // Open the drawer immediately; refresh contents + count in the background.
        document.body.classList.add('rsb-cart-busy');
        openDrawer();
        if (btn) { btn.innerHTML = '✓ Added'; setTimeout(function () { btn.innerHTML = original; btn.disabled = false; }, 1400); }
        syncCount();
        return refreshDrawer().then(function () { document.body.classList.remove('rsb-cart-busy'); });
      })
      .catch(function (err) {
        document.body.classList.remove('rsb-cart-busy');
        if (btn) { btn.innerHTML = original; btn.disabled = false; }
        alert(err.message || 'Sorry, this item could not be added.');
      });
  }

  function cartChange(line, quantity, onCartPage) {
    document.body.classList.add('rsb-cart-busy'); // show loader while updating
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: quantity }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        updateShipBar(cart);
        if (onCartPage) { window.location.reload(); return; } // loader stays until reload
        return refreshDrawer().then(function () { document.body.classList.remove('rsb-cart-busy'); });
      })
      .catch(function () { document.body.classList.remove('rsb-cart-busy'); });
  }

  function initCartDrawer() {
    // open from header cart icon
    document.querySelectorAll('[data-rsb-cart-toggle]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); refreshDrawer(); });
    });
    // delegated close + line controls
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-rsb-drawer-close]') || e.target.closest('[data-rsb-drawer-overlay]')) { closeDrawer(); return; }
      var line, container, onCartPage;
      var minus = e.target.closest('[data-rsb-cart-minus]');
      var plus = e.target.closest('[data-rsb-cart-plus]');
      var remove = e.target.closest('[data-rsb-cart-remove]');
      var node = minus || plus || remove;
      if (!node) return;
      container = node.closest('[data-rsb-line]');
      if (!container) return;
      line = parseInt(container.getAttribute('data-rsb-line'), 10);
      onCartPage = !!node.closest('[data-rsb-cart]');
      var input = container.querySelector('[data-rsb-cart-qty]');
      var current = input ? (parseInt(input.value, 10) || 1) : 1;
      if (remove) cartChange(line, 0, onCartPage);
      else if (minus) cartChange(line, Math.max(0, current - 1), onCartPage);
      else if (plus) cartChange(line, current + 1, onCartPage);
    });
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-rsb-cart-qty]');
      if (!input) return;
      var container = input.closest('[data-rsb-line]');
      if (!container) return;
      var line = parseInt(container.getAttribute('data-rsb-line'), 10);
      var onCartPage = !!input.closest('[data-rsb-cart]');
      cartChange(line, Math.max(0, parseInt(input.value, 10) || 0), onCartPage);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  // Keep the price + ATC button in sync with the selected selling plan (subscriptions)
  function initSellingPlanPrice() {
    var form = document.querySelector('[data-rsb-product-form]');
    if (!form) return;
    var dataEl = form.querySelector('[data-rsb-plan-prices]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var priceEl = document.querySelector('[data-rsb-price]');
    var btnPriceEl = document.querySelector('[data-rsb-btn-price]');
    var last = null;
    // The subscriptions app injects [name=selling_plan] and updates it asynchronously,
    // so re-query it inside the poll (it may not exist when this runs).
    setInterval(function () {
      var spField = form.querySelector('[name="selling_plan"]');
      var sp = spField ? spField.value : '';
      if (sp === last) return;
      last = sp;
      var price = (sp && data.plans && data.plans[sp]) ? data.plans[sp] : data.base;
      if (priceEl) priceEl.textContent = price;
      if (btnPriceEl) btnPriceEl.textContent = price;
    }, 250);
  }

  // Product page form -> add to cart -> drawer
  function initProductForm() {
    var form = document.querySelector('[data-rsb-product-form]');
    if (!form) return;
    var btn = form.querySelector('[data-rsb-atc]');
    function handle(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!btn || btn.hasAttribute('disabled')) return;
      var fd = new FormData(form);
      var payload = { id: fd.get('id'), quantity: parseInt(fd.get('quantity'), 10) || 1 };
      var sp = fd.get('selling_plan');
      if (sp) payload.selling_plan = sp; // subscription selling plan (when "Subscribe & save" chosen)
      addToCart(payload, btn);
    }
    // capture phase on the button so we run before any app's submit hijack
    if (btn) btn.addEventListener('click', handle, true);
    form.addEventListener('submit', handle);
  }

  // Product cards -> add to cart -> drawer
  function initCardAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rsb-card-add]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      addToCart({ id: id, quantity: 1 }, btn);
    });
  }

  // Hero slider — seamless infinite loop, watchdog-guarded so autoplay
  // never gets stuck after manual navigation.
  function initHeroSlider() {
    document.querySelectorAll('[data-rsb-slider]').forEach(setupSlider);
  }
  function setupSlider(root) {
    var track = root.querySelector('[data-rsb-slider-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-rsb-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-rsb-slider-dot]'));
    var n = slides.length;
    if (n < 2) return;
    var DUR = 550;
    var EASE = 'transform ' + DUR + 'ms cubic-bezier(.4,0,.2,1)';

    var firstClone = slides[0].cloneNode(true);
    var lastClone = slides[n - 1].cloneNode(true);
    firstClone.setAttribute('aria-hidden', 'true');
    lastClone.setAttribute('aria-hidden', 'true');
    track.insertBefore(lastClone, slides[0]);
    track.appendChild(firstClone);

    var pos = 1;          // real slides occupy positions 1..n
    var busy = false;
    var wd = null;        // watchdog timer

    function apply(animate) {
      track.style.transition = animate ? EASE : 'none';
      track.style.transform = 'translateX(-' + (pos * 100) + '%)';
    }
    function realIndex() { return ((pos - 1) % n + n) % n; }
    function syncDots() { dots.forEach(function (d, i) { d.style.background = i === realIndex() ? '#fff' : 'rgba(255,255,255,.45)'; }); }
    apply(false); syncDots();

    function settle() {
      if (wd) { clearTimeout(wd); wd = null; }
      if (pos === 0) { pos = n; apply(false); void track.offsetWidth; }
      else if (pos === n + 1) { pos = 1; apply(false); void track.offsetWidth; }
      busy = false;
    }
    track.addEventListener('transitionend', function (e) {
      if (e.target !== track || e.propertyName !== 'transform') return;
      settle();
    });

    function move(step) {
      if (busy) return;
      busy = true;
      pos += step;
      apply(true);
      syncDots();
      if (wd) clearTimeout(wd);
      wd = setTimeout(settle, DUR + 120); // fallback if transitionend never fires
    }
    function goTo(real) {
      if (busy || real === realIndex()) return;
      busy = true;
      pos = real + 1;
      apply(true);
      syncDots();
      if (wd) clearTimeout(wd);
      wd = setTimeout(settle, DUR + 120);
    }

    // autoplay
    var timer = null;
    function play() {
      stop();
      if (root.getAttribute('data-autoplay') !== 'true') return;
      var sec = parseFloat(root.getAttribute('data-speed')) || 6;
      timer = setInterval(function () { move(1); }, sec * 1000);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function nudge(step) { move(step); play(); } // reset autoplay clock after manual nav

    var prev = root.querySelector('[data-rsb-slider-prev]');
    var next = root.querySelector('[data-rsb-slider-next]');
    if (prev) prev.addEventListener('click', function () { nudge(-1); });
    if (next) next.addEventListener('click', function () { nudge(1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-rsb-slider-dot'), 10)); play(); }); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);

    // touch swipe
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) move(dx < 0 ? 1 : -1);
      x0 = null;
      play();
    }, { passive: true });

    play();
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initBurger();
    initAccordions();
    initSearch();
    initGallery();
    initQty();
    initVariant();
    initProductForm();
    initSellingPlanPrice();
    initCartDrawer();
    initCardAdd();
    initHeroSlider();
  });
})();
